module.exports = __webpack_public_path__ + "static/6-32ce20d436031ad8ff329cdcfd78870f.jpg";